import SpeakerCard from './SpeakerCard';

export default SpeakerCard;
